/*
 * @Description:
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-03-03 09:35:44
 * @LastEditors: zhangle
 * @LastEditTime: 2024-01-30 17:32:06
 */
import qs from 'qs'
/**
 * 请求统一管理
 */
import Request from '@/common/copyright/request';

// 分页查询剧集作品列表
export const dramaSearchApi = (data) => Request.post('drama/api/drama/search', data);

// 根据剧集作品ID查询剧集阶段列表
export const findDramaStageListApi = (dramaId) => Request.get(`drama/api/drama/findDramaStageList/${dramaId}`);

// 根据ID查询剧集作品
export const dramaDetailApi = (id) => Request.get(`drama/api/drama/${id}`);

// 根据最后一个剧集证据作品ID查询剧集作品
export const findDramaStageFilesApi = (data) => Request.post(`drama/api/drama/findDramaStageFiles`, data);

// 按证书编号查询详情
export const findBySerialNoApi = (serialNo) => Request.get(`drama/api/drama/findBySerialNo?serialNo=${serialNo}`);

// 扫描证书二维码 根据最后一个剧集证据作品ID和证书编号查询剧集作品
export const findDramaStageFilesBySerialNoApi = (param) => Request.get(`drama/api/drama/findDramaStageFilesBySerialNo`, param);

// 查询已认证作品总数
export const dramaCountApi = (param) => Request.get(`drama/api/drama/count`, param);





// 查询权限设置.
export const findShareInfoApi = (id) => Request.get(`drama/api/drama/shareInfo/${id}`, null, {
    customCode: 'system'
});

// 查询权限设置.
export const shareFilePageApi = (param) => Request.get(`drama/api/drama/shareFilePage`, param, {
    customCode: 'system'
})

// /api/drama/share
export const shareApi = (data) => Request.post(`drama/api/drama/share`, data, {
    customCode: 'system'
})